/**
 * [运费调控记录]
 * @author: Fu Xiaochun
 * @date: 2021-08-04 
 */

import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { message, Modal, } from 'antd';
import PropTypes from 'prop-types';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { XOKButton, XCancelButton, XInput, showConfirm, XSelect } from '@/components/xqxc_ui';
import { SearchBox, SearchItem } from '@/components/Layout';
import TableBox from './components/TableBox';
import commonModel from '@/reducers/operation/common/model';
import model from '@/reducers/system/shippingfeeset/model';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import UserControlFee from '../components/ControlFeeModal/UserControlFee';
import CompanyControlFee from '../components/ControlFeeModal/CompanyControlFee';
import { getEnum } from '@/apis/common/index';
import { stopRegulate, cancelRegulate } from '@/apis/system/shippingFee';

function ControlLog(props){

    const tid = props.location.state && props.location.state.tId || '';
    const tName = props.location.state && props.location.state.tName || '';

    const { setBreadcrumbPaths, match, getProvinces, getControlLog, controlLog, getCitys, provinces, citys, curTabID } = props;

    const [templateId, setTemplateId] = useState(tid);
    const [templateName, setTemplateName] = useState(tName);
    const [provinceItem, setProvinceItem] = useState({});
    const [cityList, setCityList] = useState(citys || []);
    const [cityItem, setCityItem] = useState([]);
    const [controlStatusOptions, setControlStatusOptions] = useState([]);
    const [controlStatus, setControlStatus] = useState({});
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(30);
    const [logData, setLogData] = useState({});
    const [userFeeControlVisible, setUserFeeControlVisible] = useState(false);
    const [companyFeeControlVisible, setCompanyFeeControlVisible] = useState(false);
    const [reset, setReset] = useState(0);


    useEffect(()=>{
        setBreadcrumbPaths(match); // 自动识别面包屑
        getProvinces({ id: 0 });
        getCitys({ id: '1' });
        getStatusEnum();
        onSearch();
    }, []);

    useEffect(()=>{
        if(provinceItem.id){
            setCityList(props.citys);
        }else{
            setCityList([]);
        }
    }, [props.citys]);

    useEffect(()=>{
        onSearch();
    }, [reset]);

    useEffect(()=>{
        onSearch();
    }, [pageSize, pageNum]);

    const getStatusEnum = ()=>{
        getEnum({enumName: 'DeliveryRegulateStatusEnum'}).then(res=>{
            setControlStatusOptions(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const provinceChange = (e)=>{
        let id = e.id;
        setCityItem({});
        if(id){
            getCitys({id});
        }else{
            setCityList([]);
        }
    };

    const onSearch = ()=>{
        let searchCache = {
            templateId,
            templateName,
            provinceId: provinceItem.id,
            cityId: cityItem.id,
            status: controlStatus.code,
            pageNum,
            pageSize
        };
        getControlLog(searchCache);
    };

    const onReset = ()=>{
        setTemplateId('');
        setTemplateName('');
        setProvinceItem({});
        setCityItem({});
        setControlStatus({});
        setPageNum(1);
        setPageSize(30);
        setReset(reset+1);
    };

    const onTableOperate = (id, type, item)=>{
        switch (type){
            case 'cancel':
                // 取消，设置调控无效
                {
                    showConfirm('确定设置无效吗？', '', () => {
                        cancelRegulate({id}).then(() => {
                                message.success('操作成功！');
                                onSearch();
                            })
                            .catch(error => {
                                message.error(error.message);
                            });
                    });
                }
                break;
            case 'edit': 
                showControlFeeModal(item);
                break;
            case 'over':
                // 终止
                showConfirm('确定设置终止吗？', '', () => {
                    stopRegulate({id}).then(() => {
                            message.success('操作成功');
                            onSearch();
                        })
                        .catch(error => {
                            message.error(error.message);
                        });
                });
                break;
            default:
                // nothing to do
        }
    };

    const onPageChange = (pageSize, pageNum) => {
        setPageNum(pageNum);        
        setPageSize(pageSize);
    };

    const showControlFeeModal = (item)=>{
        let type = item.templateTypeCode;
        
        setLogData(item);
        if(type == 'ENTERPRISE'){
            setCompanyFeeControlVisible(true);
        }
        if(type == 'USER'){
            setUserFeeControlVisible(true);
        }
    };

    const hideUserControlFeeModal = ()=>{
        setUserFeeControlVisible(false);
        onSearch();
    };
    const hideCompanyControlFeeModal = ()=>{
        setCompanyFeeControlVisible(false);
        onSearch();
    };

    const onTemplateNameChange = ()=>{
        setTemplateId();
    };

    return (
        <div className={styles.flexBoxContainer}>
            <SearchBox>
                <SearchItem>
                    <XInput
                        label='模板名称'
                        placeholder='请输入'
                        bindThis={setTemplateName}
                        bindName='templateName'
                        value={templateName}
                        showLength={false}
                        maxLength={100}
                        onChange={onTemplateNameChange}
                        allowClear={true}
                    />
                </SearchItem>
                <SearchItem>
                    <XSelect
                        label='地区'
                        placeholder='请选择省份'
                        renderData={provinces}
                        dataIndex='areaName'
                        keyIndex='id'
                        value={provinceItem.areaName}
                        bindThis={setProvinceItem}
                        bindName='provinceItem'
                        showSearch={true}
                        style={{ marginRight: '0' }}
                        onChange={provinceChange}
                        allowClear={true}
                    />
                    <XSelect
                        placeholder='请选择城市'
                        renderData={cityList}
                        dataIndex='areaName'
                        keyIndex='id'
                        value={cityItem.areaName}
                        bindThis={setCityItem}
                        bindName='cityItem'
                        showSearch={true}
                        allowClear={true}
                    />
                </SearchItem>
                <SearchItem>
                    <XSelect
                        label='状态'
                        placeholder='请选择'
                        renderData={controlStatusOptions}
                        dataIndex='value'
                        keyIndex='code'
                        value={controlStatus.code}
                        bindThis={setControlStatus}
                        bindName='controlStatus'
                        isOptionBindID={true}
                        allowClear={true}
                    />
                </SearchItem>
                <SearchItem>
                    <XOKButton
                        label='查询'
                        onClick={onSearch}
                    />
                    <XCancelButton
                        label='重置'
                        onClick={onReset}
                    />
                </SearchItem>
            </SearchBox>
            <TableBox
                shippingFees={controlLog}
                onTableOperate={onTableOperate}
                onPageChange={onPageChange}
                curTabID={curTabID}
            />
            {userFeeControlVisible ? <UserControlFee data={logData} logId={logData.id} onCancel={hideUserControlFeeModal}/> : null}
            {companyFeeControlVisible ? <CompanyControlFee data={logData} logId={logData.id} onCancel={hideCompanyControlFeeModal}/> : null}
        </div>
    );
}

ControlLog.defaultProps = {
    controlLog: {
        dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0
    },
    provinces: [],
    citys: []
};

ControlLog.propTypes = {
    history: PropTypes.object.isRequired,//路由对象
    match: PropTypes.object, // 路由match对象
    location: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
    getControlLog: PropTypes.func,
    controlLog: PropTypes.object,
    getProvinces: PropTypes.func,
    provinces: PropTypes.array,
    getCitys: PropTypes.func,
    citys: PropTypes.array,
    curTabID: PropTypes.string,
};

export default connect(state => ({
    controlLog: state.shippingFeeSet.controlLog,
    provinces: state.operationCommon.provinces,
    citys: state.operationCommon.citys
}), {
    setBreadcrumbPaths,
    ...model.actions,
    ...commonModel.actions
})(ControlLog);